import React, {
  HTMLAttributes,
  ReactNode,
} from 'react';
import c from 'classnames';

import {
  Button,
  Icon,
  isExternalLink,
} from '@uncinc/uncinc-react-kitchen-sink';

import useBubble from '../../helpers/useBubble';

interface ButtonWrapperProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  children?: ReactNode;
  onClick?: () => void;
  secondary?: boolean;
  inverted?: boolean;
  bubble?: boolean;
  href?: string;
  className?: string;
  iconName?: string;
  wrapperTransparent?: boolean;
}

const ButtonWrapper: React.FC<ButtonWrapperProps> = ({
  children,
  onClick,
  secondary = false,
  inverted = false,
  href = '',
  className = '',
  iconName = '',
  bubble = true,
  wrapperTransparent = false,
  ...props
}) => {
  const {
    BubbleComponent,
    parentRef,
    onEnter,
    onLeave,
  } = useBubble();

  let icon = iconName;

  const buttonClasses = c(className, {
    'Button--primary': !secondary,
    'Button--secondary': secondary,
    'Button--inverted': inverted,
    'Button--bubble': bubble,
  });

  if (href && !iconName) {
    icon = !isExternalLink(href) ? 'arrow_forward' : 'north_east';
  }

  if (secondary) {
    icon = 'close';
  }

  return (
    <div className={`${wrapperTransparent ? '' : 'Button__backgroundwhite'}`}>
      <div className={`${wrapperTransparent ? '' : 'Button__backgroundopaque'}`}>
        <Button
          forwardRef={parentRef}
          className={buttonClasses}
          onClick={onClick}
          onMouseEnter={onEnter}
          onMouseLeave={onLeave}
          primary={false}
          href={href}
          // This, because we implemented a higher order component
          // and remapped the KitchenSink Button.
          // Otherwise the ButtonWrapper would render twice.
          componentIsWrapped
          {...props}
        >
          {bubble && (
            <BubbleComponent />
          )}
          <div className="Button__inner">
            {children}
            {(href || secondary || icon) && (
              <Icon name={`${icon}`} />
            )}
          </div>
        </Button>
      </div>
    </div>

  );
};


export default ButtonWrapper;
